import { selectWarehouse, updateWarehouse } from '../Warehouses/warehousesSlice'
import useWarehouseAction from 'containers/Warehouse/hooks/useWarehouseAction'
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import MagNumber from 'components/MagNumber'
import Introduction from './Introduction'
import { useLayoutEffect } from 'react'
import Beginning from './Beginning'
import Photo from './Photo'
import End from './End'

const PAGES = {
  1: 'introduction',
  2: 'photo',
  3: 'end'
}

const FirstOpening = () => {
  const { id, key } = useParams()
  const { name, isAlreadyOpened = false, placeAddress } = useSelector(state => selectWarehouse(state, id))
  const { isSending, action } = useWarehouseAction(id)

  const dispatch = useDispatch()
  const { push, replace } = useHistory()

  useLayoutEffect(() => {
    if (isAlreadyOpened) replace(`/warehouses/${id}`)
    else action()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, replace, isAlreadyOpened])

  const next = path => {
    if (path) push(`/firstopening/${id}/${path}`)
    else {
      dispatch(updateWarehouse({ id, values: { isAlreadyOpened: true } }))
      replace(`/warehouses/${id}`)
    }
  }

  const header = <div>
    <MagNumber number={name} />
    <div className='slide__address'>{placeAddress}</div>
  </div>

  return (
    <main className='newWarehouse'>
      <section key={key} className={key ? '--animated' : ''}>
        <div className='slides'>
          {(() => {
            switch (key) {
              case PAGES[1]: return <Introduction
                id={id}
                isLoading={isSending}
                header={header}
                next={() => next(PAGES[3])}
              />
              case PAGES[2]: return <Photo
                header={header}
                next={() => next(PAGES[3])}
              />
              case PAGES[3]: return <End
                next={() => next()}
              />
              default: return <Beginning
                id={id}
                name={name}
                isLoading={isSending}
                next={() => next(PAGES[1])}
              />
            }
          })()}
        </div>
      </section>
    </main>
  )
}

export default FirstOpening